import { Dispatch, useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { knmTryOpenSignModal } from 'KnmPackage/MainModule/actions/knmActions';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IKnmErknmFormResultDecision } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormResultDecision';
import { IDecisionResultDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionResultDecisionForm';
import { decisionTryOpenSignModal } from 'DecisionPackage/MainModule/actions/decisionActions';
import { setDirtyResultDecisionGuid } from 'CorePackage/HeaderModule/actions/headerActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmPmFormResultDecision } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormResultDecision';

import styles from './ResultDecisionsItemContentSignButton.module.scss';
import { getIsDirtyPrescription } from './getIsDirtyPrescription';

interface IResultDecisionsItemContentSignButtonProps {
  isDisabledField: boolean;
  value: IKnmErknmFormResultDecision | IKnmPmFormResultDecision | IDecisionResultDecisionForm;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  onSaveButtonClick: (() => void) | undefined;
  isDecision?: boolean;
  isResultDecision?: boolean;
  decisionIndex: number;
  isPm?: boolean;
  name?: string;
}

interface IResultDecisionsItemContentSignButtonStoreProps {
  loading: boolean;
}

const ResultDecisionsItemContentSignButtonWithoutStore = ({
  isDisabledField,
  onSaveButtonClick,
  value,
  formRef,
  isDecision,
  isResultDecision,
  decisionIndex,
  isPm,
  name,
  loading,
}: IResultDecisionsItemContentSignButtonProps & IResultDecisionsItemContentSignButtonStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const { dirtyFields, modified } = formRef?.current?.getState() || {};

  const {
    wasEditFiled: isDirtyBySigned,
    wasEditOnlyViolations: isDirtyBySignedOnlyViolations,
  } = getIsDirtyPrescription(dirtyFields, decisionIndex, isPm, isDecision, modified);

  const onClickButtonSign = useCallback(() => {
    if (value.guid) {
      if (!isDecision) {
        dispatch(
          knmTryOpenSignModal(isResultDecision ? undefined : value.guid, isResultDecision ? value.guid : undefined),
        );
      } else {
        dispatch(
          decisionTryOpenSignModal(
            isResultDecision ? undefined : value.guid,
            isResultDecision ? value.guid : undefined,
          ),
        );
      }
    }
  }, [value, isDecision, isResultDecision]);

  useEffect(() => {
    if (!value.isNew && value.signed && value.guid && !loading) {
      const shouldUnsigned = isDirtyBySigned && !isDirtyBySignedOnlyViolations;

      if (shouldUnsigned) {
        // @ts-ignore
        formRef?.current?.change(`${name}.signed`, false);
        dispatch(setDirtyResultDecisionGuid(value.guid));
      }
    }
  }, [name, isDirtyBySigned, isDirtyBySignedOnlyViolations]);

  const onClickButtonSave = useCallback(() => {
    onSaveButtonClick && onSaveButtonClick();
  }, [onSaveButtonClick]);

  let buttonTitle = '';

  if (isDirtyBySigned) {
    buttonTitle = 'Сохранить предписание';
  } else if (value.signed) {
    buttonTitle = 'Предписание подписано';
  } else if (value.isNew) {
    buttonTitle = 'Сохранить предписание';
  } else {
    buttonTitle = 'Подписать предписание';
  }

  return (
    <div className={styles.RowForButtonSign}>
      <Button
        color="primary"
        text={buttonTitle}
        id="saveButton"
        type={'button'}
        disabled={isDirtyBySigned ? false : isDisabledField || value.signed}
        onClick={value.isNew || isDirtyBySigned ? onClickButtonSave : onClickButtonSign}
        className={styles.ButtonSign}
      />
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  loading: state.core.loading > 0,
  loadingProgress: state.core.loadingProgress,
});

export const ResultDecisionsItemContentSignButton = connect(mapStateToProps)(
  ResultDecisionsItemContentSignButtonWithoutStore,
);
